import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faTrashAlt } from '@fortawesome/pro-light-svg-icons'

import { Button, Form } from '@domain-group/suit-theme'

import { confirmDelete } from '@functions/entity'

import ScopedConditionalContent from '@components/ScopedConditionalContent'
import useCurrentUser from '@hooks/useCurrentUser'
import type { useCreateOrEditOrderItemTaskModalPayload } from '../../hooks/useCreateOrEditOrderItemTaskModal'

import type { ModalCallbacks } from '../../index'

interface OptionsProps {
  callbacks: ModalCallbacks,
  hookPayload: useCreateOrEditOrderItemTaskModalPayload,
}

const Options = (props: OptionsProps) => {
  const { callbacks, hookPayload } = props

  const {
    closeModal,
    completeOrderItemTask,
  } = callbacks

  const {
    callbacks: {
      completeOrderItemTask: completeFn,
      deleteOrderItemTask: deleteFn,
    },
    canDeleteTask,
    deleting,
    formPayload: { entityState },
    status,
    updating,
  } = hookPayload

  const { isAgencyAdmin, isProviderUser } = useCurrentUser()

  const confirmDeletePayload = {
    callbacks: {
      afterAction: closeModal,
      deleteFn,
    },
    strings: { entityName: 'Task' },
  }

  const completeOrderItemTaskPayload = {
    callbacks: {
      action: completeFn,
      afterAction: closeModal,
    },
    entityParams: entityState,
    toastText: 'Task Completed',
  }

  // @ts-expect-error TS2339
  const showDelete = (isProviderUser && status.key !== 'complete') || (isAgencyAdmin && canDeleteTask)

  // @ts-expect-error TS2339
  if (!showDelete && !(isProviderUser && status.key === 'approved')) return null

  return (
    <Form.Field label="More Options" marginTop="large">
      {showDelete && (
        <Button
          buttonStyle="secondaryUtility"
          icon={<FontAwesomeIcon icon={faTrashAlt} />}
          loading={deleting}
          onClick={() => confirmDelete(confirmDeletePayload)}
          size="medium"
        >
          Delete Task
        </Button>
      )}

      <ScopedConditionalContent
        permittedRoleTitles={['Provider Contractor', 'Provider Director', 'Provider Employee']}
      >
        {/*
         // @ts-expect-error TS2339 */}
        {(status.key === 'approved') && (
        <Button
          buttonStyle="secondaryUtility"
          icon={<FontAwesomeIcon icon={faCheck} />}
          loading={updating}
          // @ts-expect-error TS2339
          marginTop={status.key !== 'complete' ? 'medium' : 0}
          onClick={() => completeOrderItemTask(completeOrderItemTaskPayload)}
          size="medium"
        >
          Mark as Complete
        </Button>
        )}
      </ScopedConditionalContent>
    </Form.Field>
  )
}

export default Options
